// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-title[data-v-319943ea]{border-left-style:solid;-o-border-image:linear-gradient(180deg,transparent,var(--v-primary-base),transparent) 1 100%;border-image:linear-gradient(180deg,transparent,var(--v-primary-base),transparent) 1 100%;border-left-width:3px;padding:20px}.section-title h1[data-v-319943ea]{font-size:20px;font-weight:700}.section-title h3[data-v-319943ea]{font-weight:400}", ""]);
// Exports
module.exports = exports;
